var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback, useState } from 'react';
import { apiGetListColumn } from '@/actions/ColumnActionsTs';
import { wrapDispatch } from '@/utils/actions/dispatch';
import { parseColumnListData, } from '@/utils/resources/article/parseArticleListData';
/**
 * コラム情報を取得するカスタムフック
 */
export const useClientTopPageFetchColumn = (options) => {
    const { dispatch } = options;
    // コラムのデータを保存
    const [columnList, setColumnList] = useState(null);
    /**
     * コラム情報取得
     */
    const fetchColumn = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        const { payload } = yield wrapDispatch(dispatch, apiGetListColumn({ query: { page: 1 } }, {}));
        // 整形する
        const articles = parseColumnListData(payload);
        // 取得したデータをstateに保存
        setColumnList((articles === null || articles === void 0 ? void 0 : articles.list) || null);
    }), [dispatch, setColumnList]);
    return {
        columnList,
        fetchColumn,
    };
};
